<template>
<div class="full-width">
  <div class="empty-page">
    <div class="box-center">
      <tl-header type="h2">Hey! Looks like you're lost</tl-header>
      <btn-grp>
        <btn text="Go To Home" type="secondary" @click="$router.push('/')" />
        <btn text="Back to where you came from" type="secondary" @click="$router.go(-1)" />
      </btn-grp>
    </div>
  </div>
</div>
</template>

<script>
export default {}
</script>
<style lang="scss" scoped>
.empty-page {
    height: 100vh;
    width: 100%;
    background-image: linear-gradient(to bottom, #ffffff, #3ad0c3);
    align-items: center;
    display: flex;
    justify-content: center;
}
.box-center {
    margin: auto;
    position: absolute;
    // box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);
    padding: 50px;
}
</style>
